import React from 'react'
import TextoEnriquecido from './TextoEnriquecido'
const BannerPaginaIndividual = (props) => {
    return (
        <div className='banner-pagina-individual'>
            <TextoEnriquecido {...props} />
        </div>
    )
}

export default BannerPaginaIndividual